module.exports = __webpack_public_path__ + "static/media/1.2 in 1 Battery Sprayer.e3a7ab72.png";